import { Button, Typography } from "@mui/material";
import UpdateIcon from "@mui/icons-material/Update";
import { buttonColors, colors } from "../../utility/types/constant";

interface UpdateCircleSettingsBtnProps {
  onClick: () => void;
}

const UpdateCircleSettingsBtn = (props: UpdateCircleSettingsBtnProps) => {
  const { onClick } = props;

  return (
    <Button
      onClick={onClick}
      variant="outlined"
      sx={{
        borderColor: buttonColors.mainPrimary,
        color: colors.mainPrimary,
      }}
      startIcon={<UpdateIcon />}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: colors.darkGrey,
        }}
      >
        Settings
      </Typography>
    </Button>
  );
};

export default UpdateCircleSettingsBtn;
